import { Navigate, useLocation } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useCheckit } from '@/lib/checkit/CheckitAuthContext';

// Gate for authenticated checkit pages (app, account).
export default function RequireCheckitAuth({ children }) {
  const { isAuthed, loading } = useCheckit();
  const location = useLocation();

  if (loading) {
    return (
      <div className="checkit-scope min-h-screen flex items-center justify-center bg-background" data-testid="checkit-auth-loading">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }
  if (!isAuthed) {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?next=${next}`} replace />;
  }
  return children;
}
